import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEthereumComponent } from './simple-icons-ethereum.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEthereumComponent ],
    exports:      [ SimpleIconsEthereumComponent ],
    bootstrap:    []
})
export class SimpleIconsEthereumModule {}
